import React from 'react';
import propTypes from 'prop-types';
export const CityIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M12 6L12 24L19 24L19 12L24 12L24 6L12 6 z M 15 8L17 8L17 10L15 10L15 8 z M 19 8L21 8L21 10L19 10L19 8 z M 15 12L17 12L17 14L15 14L15 12 z M 21 14L21 39L28 39L28 20L34 20L34 14L21 14 z M 15 16L17 16L17 18L15 18L15 16 z M 24 16L26 16L26 18L24 18L24 16 z M 29 16L31 16L31 18L29 18L29 16 z M 15 20L17 20L17 22L15 22L15 20 z M 24 20L26 20L26 22L24 22L24 20 z M 30 22L30 39L42 39L42 22L30 22 z M 24 24L26 24L26 26L24 26L24 24 z M 33 24L35 24L35 26L33 26L33 24 z M 37 24L39 24L39 26L37 26L37 24 z M 8 26L8 39L19 39L19 26L8 26 z M 11 28L13 28L13 30L11 30L11 28 z M 15 28L17 28L17 30L15 30L15 28 z M 24 28L26 28L26 30L24 30L24 28 z M 33 28L35 28L35 30L33 30L33 28 z M 37 28L39 28L39 30L37 30L37 28 z M 6 30.919922L-0.029296875 45L50.140625 45L44 31.839844L44 41L6 41L6 30.919922 z M 11 32L13 32L13 34L11 34L11 32 z M 15 32L17 32L17 34L15 34L15 32 z M 24 32L26 32L26 34L24 34L24 32 z M 33 32L35 32L35 34L33 34L33 32 z M 37 32L39 32L39 34L37 34L37 32 z" />
    </svg>
  );
};
CityIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
CityIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
